import React from "react";
import PropTypes from "prop-types";
// @material-ui/core components
import { makeStyles } from "@material-ui/core/styles";
import Box from "@material-ui/core/Box";
import Container from "@material-ui/core/Container";
import Grid from "@material-ui/core/Grid";

// core components

import componentStyles from "assets/theme/components/headers/simple-header.js";

const useStyles = makeStyles(componentStyles);

const DoobiHeader = ({ section, subsection }) => {
  const classes = useStyles();
  return (
    <>
      <div className={classes.header}>
        <Container
          maxWidth={false}
          component={Box}
          classes={{ root: classes.containerRoot }}
        >
          <Grid
            container
            component={Box}
            alignItems="center"
            paddingTop="1.5rem"
            paddingBottom="1.5rem"
          >
            {/* 2 Orders Pending Action */}
          </Grid>
        </Container>
      </div>
    </>
  );
};

DoobiHeader.propTypes = {
  section: PropTypes.string
};

export default DoobiHeader;
